import { InternalDatabaseService } from './shared/storage/internal/internal-database.service';
import { Component, OnInit, ApplicationRef, NgZone, OnDestroy } from '@angular/core';
import { IconService } from '@stockcare-services/icon-service/icon.service';
import { ActivityService } from '@stockcare-services/activity-service/activity.service';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { PollingServicesService } from '@stockcare-services/polling-services/polling-services.service';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { ApplicationInsightsService } from '@stockcare-services/application-insights/application-insights.service';
import { SignalRService } from '@stockcare-services/signal-r/signal-r.service';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();

  constructor(
    private iconService: IconService,
    private activityService: ActivityService,
    private deviceService: DeviceService,
    private internalDatabaseService: InternalDatabaseService,
    private router: Router,
    pollingServices: PollingServicesService,
    appRef: ApplicationRef,
    private zone: NgZone,
    applicationInsightsService: ApplicationInsightsService,
    signalRService: SignalRService,
    settingService: SettingsService
  ) {
    const appIsStable$ = appRef.isStable.pipe(first((isStable) => isStable === true));

    appIsStable$.subscribe(() => {
      console.log('App is stable');
      pollingServices.initialize().then(() => {
        signalRService.startConnection();
      });

      applicationInsightsService.initialize();
    });

    signalRService.ensureConnected();
  }

  ngOnInit() {
    this.internalDatabaseService.initialiseDatabase();

    this.iconService.initializeIcons();

    this.subscriptions.add(
      this.activityService.userIsInactive.subscribe(() => {
        console.log('Should log out user due to inactivity');

        if (this.deviceService.isWhiteboardDevice()) {
          return;
        }

        if (this.deviceService.isTheaterOperationInProgress()) {
          return;
        }

        this.zone.run(() => {
          this.router.navigate(['app/signout']);
        });
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
